// import classNames from 'classnames';
// import React from 'react';

// const Table = ({ tableInstance, className = 'react-table boxed' }) => {
//   const {
//     getTableProps,
//     headerGroups,
//     page,
//     getTableBodyProps,
//     prepareRow,
//     toggleAllPageRowsSelected,
//     onOpenEditModal,
//   } = tableInstance;
//   return (
//     <>
//       <table className={className} {...getTableProps()}>
//         <thead>
//           {headerGroups.map((headerGroup, headerIndex) => (
//             <tr key={`header${headerIndex}`} {...headerGroup.getHeaderGroupProps()}>
//               {headerGroup.headers.map((column, index) => {
//                 return (
//                   <th
//                     key={`th.${index}`}
//                     {...column.getHeaderProps(column.getSortByToggleProps())}
//                     className={classNames(column.headerClassName, {
//                       sorting_desc: column.isSortedDesc,
//                       sorting_asc: column.isSorted && !column.isSortedDesc,
//                       sorting: column.sortable,
//                     })}
//                   >
//                     {column.render('Header')}
//                   </th>
//                 );
//               })}
//             </tr>
//           ))}
//         </thead>
//         <tbody {...getTableBodyProps()}>
//           {page.map((row, i) => {
//             prepareRow(row);

//             return (
//               <tr
//                 key={`tr.${i}`}
//                 {...row.getRowProps()}
//                 className={classNames({ selected: row.isSelected })}
//               >
//                 {row.cells.map((cell, cellIndex) => (
//                   <td
//                     key={`td.${cellIndex}`}
//                     {...cell.getCellProps()}
//                     onClick={() => {
//                       if (cell.column.id === 'name') {
//                         toggleAllPageRowsSelected(false);
//                         row.toggleRowSelected();
//                         onOpenEditModal();
//                       } else {
//                         row.toggleRowSelected();
//                       }
//                     }}
//                   >
//                     {cell.render('Cell')}
//                   </td>
//                 ))}
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>
//     </>
//   );
// };
// export default Table;

import classNames from 'classnames';
import React from 'react';

const Table = ({ tableInstance, className = 'react-table boxed' }) => {
  const {
    getTableProps,
    headerGroups,
    page,
    getTableBodyProps,
    prepareRow,
    toggleAllPageRowsSelected,
    onOpenEditModal,
  } = tableInstance;

  const hasData = page && page.length > 0;

  return (
    <>
      <table className={className} {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup, headerIndex) => (
            <tr key={`header${headerIndex}`} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <th
                  key={`th.${index}`}
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  className={classNames(column.headerClassName, {
                    sorting_desc: column.isSortedDesc,
                    sorting_asc: column.isSorted && !column.isSortedDesc,
                    sorting: column.sortable,
                  })}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody {...getTableBodyProps()}>
          {hasData ? (
            page.map((row, i) => {
              prepareRow(row);
              return (
                <tr
                  key={`tr.${i}`}
                  {...row.getRowProps()}
                  className={classNames({ selected: row.isSelected })}
                >
                  {row.cells.map((cell, cellIndex) => (
                    <td
                      key={`td.${cellIndex}`}
                      {...cell.getCellProps()}
                      onClick={() => {
                        if (cell.column.id === 'name') {
                          toggleAllPageRowsSelected(false);
                          row.toggleRowSelected();
                          onOpenEditModal();
                        } else {
                          row.toggleRowSelected();
                        }
                      }}
                    >
                      {cell.render('Cell')}
                    </td>
                  ))}
                </tr>
              );
            })
          ) : (
            <tr>
              <td
                colSpan={headerGroups[0]?.headers?.length || 1}
                className="text-center py-4 text-muted"
              >
                <strong>No data available</strong> with the selected filters.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default Table;
